import 'css-chunksrc/client/scenes/notifications/notification/exportBiFinished/styles.scss';export default {
  "notification": "_notification_10pq4_1",
  "header": "_header_10pq4_8",
  "title": "_title_10pq4_18",
  "main": "_main_10pq4_24",
  "text": "_text_10pq4_28",
  "status": "_status_10pq4_35",
  "completed": "_completed_10pq4_38",
  "partial": "_partial_10pq4_41",
  "failed": "_failed_10pq4_44",
  "link": "_link_10pq4_48"
};